<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Edit Profile">
    <template v-slot:body>
      <div class="row gutters">
        <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
          <div class="card h-100">
            <div class="card-body">
              <div class="account-settings">
                <div class="user-profile">
                  <div class="user-avatar mb-4">
                    <ThumbnailPreview :value="user.upload_avatar || user.avatar || avatar" class="design-thumbnail mt-1"></ThumbnailPreview>
                    <ButtonUpload :config="{ type: 'list', uploadFromUrl: false }" v-model="user.upload_avatar" />
                  </div>
                  <h5 class="user-name text-center">{{ user.display_name }}</h5>
                  <h6 class="user-email text-center">{{ user.email }}</h6>
                </div>
                <div class="about">
                  <h5>About</h5>
                  <div v-html="user.about"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
          <div class="card h-100">
            <div class="card-body">
              <div class="row gutters">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <h6 class="mb-2 text-primary">Personal Details</h6>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label for="fullName">Full Name</label>
                    <input type="text" class="form-control" placeholder="Enter full name" v-model="user.display_name" />
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label for="phone">Phone</label>
                    <input type="text" class="form-control" placeholder="Enter phone number" v-model="user.phone" />
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label for="eMail">Email</label>
                    <input type="email" class="form-control" placeholder="Enter email ID" v-model="user.email" />
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label for="eMail">Telegram</label>
                    <input type="email" class="form-control" placeholder="Enter telegram user name" v-model="user.meta.connection.telegram.user_name" />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="eMail">About</label>
                    <textarea class="form-control" v-model="user.about"></textarea>
                  </div>
                </div>
              </div>
              <div class="row gutters">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <h6 class="mt-3 mb-2 text-primary">Password</h6>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label for="Street">Password</label>
                    <input type="password" class="form-control" placeholder="Password" v-model="user.password" />
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label for="Street">Confirm password</label>
                    <input type="password" class="form-control" placeholder="Confirm password" v-model="user.confirm_password" />
                  </div>
                </div>
              </div>
              <div class="row gutters">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="text-right">
                    <button type="button" id="submit" name="submit" class="btn btn-primary" @click.stop.prevent="submit()">Update</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import ButtonUpload from '@/components/ButtonUpload.vue'
import ThumbnailPreview from '@/components/ThumbnailPreview.vue'
import Event from '@/helper/event.js'
import avatar from '@/../assets/imgs/avatar.png'
export default {
  mixins: [Event],
  components: {
    Header,
    SideBar,
    Body,
    ButtonUpload,
    ThumbnailPreview
  },
  data() {
    return {
      avatar,
      user: {
        avatar: null,
        meta: {
          connection: {
            telegram: {
              user_name: null
            }
          }
        }
      }
    }
  },
  computed: {
    getUri() {
      return `user/get/${this.$util.options.user?.id}`
    },
    submitUri() {
      return `user/update/${this.$util.options.user?.id}`
    },
    avatarPreview() {
      return this.user.avatar || this.avatar
    }
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.user = this.$util.mergeLeft(this.user, rawData?.data || {})
      }
    },
    submit() {
      this.submitForm(this.user)
    }
  }
}
</script>
<style lang="scss">
.page-edit-profile {
  .user-avatar {
    width: 100%;
    position: relative;
    cursor: pointer;
    margin: auto;
    max-width: 200px;
    .btn-upload {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      background: #fff;
      border: 0 !important;
      border-radius: 0 !important;
      color: transparent !important;
      &:hover {
        opacity: 0.25;
      }
      label {
        height: 100%;
      }
    }
    .thumbnail-preview-wrapper {
      width: 100%;
    }
  }
  .about {
    border-top: 1px solid #efefef;
    padding-top: 20px;
    margin-top: 20px;
  }
}
</style>
